import { sendData,getData } from './../../misc/server.js';
export default {
  state: {

     data:[],
     loading:false,
        
  },
  mutations: {
  
   setData(state,payload)
   {
       state.data=payload;
   },
   setLoading(state,payload)
   {
       state.loading=payload;
   }
    
  
   
  },
   actions: {
   
        getPatientMetaData({commit},data)
        {
                var url="/checkings/metadata/get";
                
                var township_id=localStorage.getItem("township_id");

                url+="?township_id="+township_id;

                url+="&";

               
                commit("setLoading",true);  
                getData(url,(response)=>{
                   
                    commit("setData",response); 
                    commit("setLoading",false);  
                })
        }
   
 
   


  },
  getters: {
     symptons(state)
     {
         return state.data.symptons;
     },

     submit_departments(state)
     {
         return state.data.submitdepartments;
     },
      submit_types(state)
     {
         return state.data.submittypes;
     }
     ,
      submit_types(state)
     {
         return state.data.submittypes;
     }
        ,
      foundplaces(state)
     {
         return state.data.foundplaces;
     },
     risk_factors(state)
     {
         return state.data.risk_factors;

     },
     patient_sccs(state)
     {
         return state.data.sccs;

     },
     presumptive_number(state)
     {
        return state.data.presumptive_number;
     },
     meta_volunteers(state)
     {
         return state.data.volunteers;
     },

     meta_data_loading(state)
     {
         return state.loading;
     }


 
  }
}